import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { DESKTOP_BREAKPOINT, FOOTER_HEIGHT_DESKTOP, FOOTER_HEIGHT_MOBILE } from '../../utils';

export const FooterContainer = styled.footer`
	display: flex;
	align-items: center;
	height: ${FOOTER_HEIGHT_DESKTOP}px;
	background-color: ${({ theme }) => theme.colors.neutral.black};
	position: relative;

	&::before {
		content: '';
		position: absolute;
		right: 0;
		bottom: 0;
		background: ${({ theme }) => theme.colors.primary.medium};
		width: 50%;
		height: 100%;
		clip-path: polygon(10% 1%, 100% 0, 100% 100%, 0% 100%);

		@media (max-width: ${DESKTOP_BREAKPOINT}px) {
			display: none;
		}
	}

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		height: ${FOOTER_HEIGHT_MOBILE}px;
	}
`;

export const FooterContent = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: auto;
	color: ${({ theme }) => theme.colors.neutral.white};
	width: 1200px;
	padding: 0 16px;
	z-index: 1;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		width: 100%;
		flex-direction: column;
		gap: 16px;
	}
`;

export const Copyright = styled.p`
	text-align: center;
`;

export const HomeLink = styled(Link)`
	color: ${({ theme }) => theme.colors.primary.medium};

	&:hover {
		text-decoration: underline;
	}
`;

export const AppsUl = styled.ul`
	display: flex;
	justify-content: flex-end;
	gap: 15px;
	height: 40px;
	list-style: none;
	z-index: 1;

	a {
		display: inline-flex;
	}
`;
